export default __webpack_public_path__ + "static/media/mal.1612de36.png";